import { render, staticRenderFns } from "./FilterDropdownCheckboxCoupon.vue?vue&type=template&id=37b11889&scoped=true&"
import script from "./FilterDropdownCheckboxCoupon.vue?vue&type=script&lang=js&"
export * from "./FilterDropdownCheckboxCoupon.vue?vue&type=script&lang=js&"
import style0 from "./FilterDropdownCheckboxCoupon.vue?vue&type=style&index=0&id=37b11889&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b11889",
  null
  
)

export default component.exports